<div style="padding: 30px">
    <div class="datebg">
        <div
            class="card text-white bg-light mb-3 info_item"
            style="margin-top: 10px"
        >
            <div class="card-header">區間數據
                <input type="text"
                    *ngIf="time"
                    class="form-control"
                    ngxDaterangepickerMd
                    [(ngModel)]="time"
                    [autoApply]="true"
                    [ranges]="ranges" [alwaysShowCalendars]="true"
                    [locale]="{applyLabel: 'ok', format: 'YYYY-MM-DD'}"
                    [opens]="'right'"
                    [minDate]="time.minDate"
                    [maxDate]='time.maxDate'
                    (change)="onRangeSelected(1,$event)"
                    (blur)="onDateTyped($event)"
                    style="width: 260px;display: inline-block;margin-right: 16px;"
                >
            </div>
            <div class="card-body">
                <div class="card-text top_info_num">三竹點數：<span class="show_it">{{top_info.sms_points|number}}</span></div>
                <div class="card-text top_info_num">發送簡訊：<span class="show_it">{{top_info.send_num|number}}</span></div>
                <div class="card-text top_info_num">點擊次數：<span class="show_it">{{top_info.total_click|number}}</span></div>
                <div class="card-text top_info_num">回歸人數：<span class="show_it">{{top_info.total_login|number}}</span></div>
                <div class="card-text top_info_num">儲值金額：<span class="show_it">{{top_info.total_recharge_val|number}}</span></div>
            </div>
        </div>
        <hr />
        <ul class="nav nav-tabs" style="margin: 10px 0 15px 0">
            <li *ngFor="let item of menu_list;let i = index" class="nav-item"  style="cursor:pointer"  (click)="choose(item.id)">
                <span   [ngClass]="now==item.id?'active':''" class="nav-link" href="#">{{item.name}}</span>
            </li>
        </ul>
    </div>
    <button
        *ngIf="now=='2'"
        class="btn btn-primary"
        style="margin: 10px"
        data-toggle="modal"
        data-target="#settingDataModal"
        (click)="get_default_data();subnow='1'"
    >
        點我設定
    </button>
    <div *ngIf="now == '1' || now =='2'">
        <div class="user_edit_block"  *ngIf="now=='1'">
            <div *ngIf="!loading">
                <highcharts-chart
                    [Highcharts]="Highcharts"
                    [(update)]="updateFlag"
                    [oneToOne]="true"
                    [options]="lineOptions2"
                    style="display:block;width:65%;margin:6px">
                </highcharts-chart>
            </div>
        </div>

        <table class="table table-responsive-sm" *ngIf="data.length > 0">
            <thead>
                <tr class="table-primary">
                    <th>描述</th>
                    <th>開始時間</th>
                    <th>結束時間</th>
                    <th>觸及轉換率</th>
                    <th>登入轉換率</th>
                    <!-- <th>數量</th> -->
                    <th>發送數量</th>
                    <th>點擊次數</th>
                    <th>登入人數</th>
                    <th>狀態</th>
                    <th>操作</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let item of data; let i = index" class="{(index % 2 ==0)?'table-secondary':'table-light'}">
                    <td>{{item.description}}</td>
                    <td>{{item.start_time}}</td>
                    <td>{{item.end_time}}</td>
                    <td>{{item.trans_touch|number}}%</td>
                    <td>{{item.trans_login|number}}%</td>
                    <!-- <td>{{item.gift_num|number}}</td> -->
                    <td>{{item.send_num==0?'不限':item.send_num}}</td>
                    <td>{{item.total_click}}</td>
                    <td>{{item.total_login}}</td>
                    <td>{{item.status==1?'上架':'下架'}}</td>
                    <td>
                        <span *ngIf="!item.can" class="tips">已過期</span>
                        <a
                            *ngIf="item.can"
                            (click)="checktag(item);"
                            href="javascript:void(0)"
                            title="點我設定"
                            data-toggle="modal"
                            data-target="#settingDataModal"
                        >
                            <i style="margin: 0 10px 0 0" class="fas fa-wrench"></i>
                        </a>
                        <a href="javascript:void(0)" title="追蹤資料明細"  (click)="edit_data=item;subnow='2';get_track_detail();" data-toggle="modal" data-target=".bd-example-modal-xl">
                            <i style="margin: 0 10px 0 10px;" class="fas fa-list-ul"></i>
                        </a>
                        <a href="javascript:void(0)" title="報表" (click)="edit_data=item;subnow='3';get_track_detail();" data-toggle="modal" data-target=".bd-example-modal-xl">
                            <i style="margin-right:10px" class="fas fa-chart-line"></i>
                        </a>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <app-pagnation  (callback)="callback($event)" [data]="pageobjstr"></app-pagnation>
</div>

<div
    class="modal fade bd-example-modal-xl"
    tabindex="-1"
    role="dialog"
    data-keyboard="false"
    data-backdrop="static"
    aria-labelledby="settingDataModal"
    aria-hidden="true"
    id="settingDataModal"
>
    <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <!-- Modal Header -->
            <div class="modal-header">
                <h5 class="modal-title">{{subnow=='1'?'設定':'觀看'}}</h5>
                <button type="button" class="close" data-dismiss="modal">
                    &times;
                </button>
            </div>

            <!-- Modal body -->
            <div class="modal-body">
                <div class="user_edit_block"  *ngIf="subnow=='3'">
                    <div *ngIf="!loading">
                        <highcharts-chart  [Highcharts]="Highcharts" [(update)]="updateFlag" [options]="lineOptions"  style="display: block;width: 65%;margin:6px"></highcharts-chart>
                    </div>
                </div>

                <div class="user_edit_block" *ngIf="subnow=='2'">
                    <select class="form-control" style="width: 160px;display: inline-block;margin:10px" [(ngModel)]="edit_data.loging_status" (change)="get_track_detail()">
                        <option *ngFor="let item of login_list" [ngValue]="item.id">{{item.name}}</option>
                    </select>
                    <select class="form-control" style="width: 160px;display: inline-block;margin:10px" [(ngModel)]="edit_data.click_status"  (change)="get_track_detail()">
                        <option *ngFor="let item of click_list" [ngValue]="item.id">{{item.name}}</option>
                    </select>
                    <select class="form-control" style="width: 160px;display: inline-block;margin:10px" [(ngModel)]="edit_data.deposit_status" (change)="get_track_detail()">
                        <option *ngFor="let item of deposit_list" [ngValue]="item.id">{{item.name}}</option>
                    </select>
                    <input type="text"  [(ngModel)]="edit_data.search_model" (keyup.enter)="get_track_detail()" placeholder="請輸入想搜尋的人名後點enter" class="form-control" style="width: 260px;display: inline;">
                    <div>共{{pageobj2.total_count}}筆</div>
                    <table style="margin-top: 10px;" class="table table-responsive-sm" *ngIf="edit_data.track_list && edit_data.track_list.length>0" style="margin-top: 6px;">
                        <thead>
                            <tr class="table-primary" style="font-size:18px;">
                                <th>發送時間</th>
                                <th>電話</th>
                                <th>頭貼</th>
                                <th>名稱</th>
                                <th>是否登入</th>
                                <th>儲值次數</th>
                                <th>儲值金額</th>
                                <th>內容</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of edit_data.track_list; let i = index" class="{{(item.now_num*1>=item.used_max_num*1)?'table-secondary':'table-light'}}">
                                <td>{{item.create_dt}}</td>
                                <td>{{item.phone_num}}</td>
                                <td>
                                    <img loading="lazy" style="height: 30px;" [src]="item.profile_pic">
                                </td>
                                <td>{{item.name}}</td>
                                <td>{{item.login_status}}</td>
                                <td>{{item.recharge_num}}</td>
                                <td>{{item.recharge}}</td>
                                <td>
                                  <span style="width: 200px;
                                  max-height: 200px;
                                  overflow: auto;
                                  word-wrap: break-word;
                                  white-space: normal;">{{item.content}}</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <app-pagnation (callback)="callback2($event)" [data]="pageobjstr2"></app-pagnation>
                    <div *ngIf="edit_data.track_list && edit_data.track_list.length==0">無資料</div>
                </div>
                <div class="user_edit_block" *ngIf="subnow=='1'">
                    <div class="mt-3">
                        <label for="content" class="form-check-label">扮演對象：</label>
                        <button  [ngClass]="setting_data.target_user_id=='-1'?'btn-danger':'btn-secondary'"   (click)="setting_data.target_user_id='-1';setting_data.target_user_profile_pic='';fresh_view_var_btn()" class="btn">不限制</button>
                        <button  [ngClass]="setting_data.target_user_id!='-1'?'btn-danger':'btn-secondary'" (click)="setting_data.target_user_id='1'" class="btn">指定</button>
                        <img loading="lazy" style="height: 80px;margin: 5px;" [src]="setting_data.target_user_profile_pic" *ngIf="setting_data.target_user_profile_pic.length>0">
                        <div *ngIf="setting_data.target_user_id!='-1' && setting_data.target_user_profile_pic.length==0" style="margin: 5px;">
                            <input type="text"  [(ngModel)]="tool_obj.search_model" (keyup.enter)="search()" placeholder="請輸入想搜尋的人名後點enter" class="form-control" style="width: 260px;display: inline;">
                            <!-- <button class="btn btn-primary" (click)="search()">確認</button> -->
                            <br>
                            <button  *ngFor="let item of tool_obj.check_user_info; let i = index"  (click)="choose_user(item)"  class="btn btn-info">
                                <img loading="lazy" style="height: 80px;" [src]="item.profile_pic">
                            </button>
                            <div *ngIf="tool_obj.search_result_staus && tool_obj.check_user_info.length == 0">無資料</div>
                        </div>
                        <hr>
                    </div>
                    <div class="">
                        <div class="mt-3">
                            <label for="content" class="form-check-label">描述：<span class="tips">描述本次設定</span></label>
                            <textarea [(ngModel)]="setting_data.description" class="form-control"></textarea>
                        </div>

                        <!-- ===== Coze 文案設定器（放在「可用變數」上方）===== -->
                        <div class="coze-box">
                            <div class="coze-head">
                                <div>
                                    <div class="coze-title">Coze 文案產生器</div>
                                    <div class="coze-sub">設定模式/強度/表情/葛格 → 自動組 prompt → 丟 Coze → 回填內容</div>
                                </div>

                                <div class="coze-actions">
                                    <button type="button" class="btn btn--ghost" (click)="resetGen()">重置</button>
                                    <button type="button" class="btn btn--primary" (click)="generateByCoze()" [disabled]="loading">
                                        {{ loading ? '產生中...' : '✨ 用 Coze 產生文案' }}
                                    </button>
                                </div>
                            </div>

                            <div class="coze-grid">
                                <!-- 模式 -->
                                <div class="field">
                                    <label class="label">模式</label>
                                    <div class="seg">
                                        <button type="button" class="seg-btn" *ngFor="let m of modes"
                                            [class.active]="gen.mode === m.value"
                                            (click)="gen.mode = m.value; syncGenParams()">
                                            {{ m.label }}
                                        </button>
                                    </div>
                                </div>

                                <!-- 強度 -->
                                <div class="field">
                                    <label class="label">強度：<b>{{ gen.intensity }}</b></label>
                                    <input class="range" type="range" min="1" max="5" step="1" [(ngModel)]="gen.intensity" (input)="syncGenParams()">
                                    <div class="range-meta">
                                        <span>1保守</span><span>3剛好</span><span>5很黏</span>
                                    </div>
                                </div>

                                <!-- 長度 -->
                                <div class="field">
                                    <label class="label">長度</label>
                                    <select class="select" [(ngModel)]="gen.len" (change)="syncGenParams()">
                                        <option value="short">短（2~3行）</option>
                                        <option value="mid">中（3~6行）</option>
                                        <option value="long">長（6~10行）</option>
                                    </select>
                                </div>

                                <!-- 開關 -->
                                <div class="field">
                                    <label class="label">選項</label>
                                    <div class="toggles">
                                        <label class="toggle">
                                            <input type="checkbox" [(ngModel)]="gen.emoji" (change)="syncGenParams()">
                                            <span>表情</span>
                                        </label>

                                        <!-- <label class="toggle">
                                            <input type="checkbox" [(ngModel)]="gen.gege" (change)="syncGenParams()">
                                            <span>叫葛格</span>
                                        </label> -->
                                    </div>
                                </div>

                                <!-- 使用者補充 -->
                                <div class="field field--full">
                                    <label class="label">補充需求（會送給 Coze 的 message，可空）</label>
                                    <input class="input" type="text" [(ngModel)]="gen.message" (input)="syncGenParams()" placeholder="例：他兩天沒回我了，想要吃醋一點但不要太兇">
                                </div>

                                <!-- 送去 Coze 的參數預覽（方便你 debug） -->
                                <div class="field field--full" *ngIf="false">
                                    <label class="label">Coze Start 參數預覽</label>
                                    <pre class="preview">{{ cozePayload | json }}</pre>
                                </div>
                            </div>
                        </div>
                        <!-- ===== /Coze 文案設定器 ===== -->
                        <div>
                            <h5>可用變數:</h5>
                            <span  *ngFor="let item of varable_list">
                                <button
                                    class="btn btn-primary mr-2"
                                    (click)="add_var(item.id)"
                                    *ngIf="item.show"
                                >
                                    {{ item.name }}
                                </button>
                            </span>
                        </div>
                    <div>
                    <label for="content" class="form-check-label">內容：</label>
                    <textarea
                        [(ngModel)]="setting_data.content"
                        (change)="check(0)"
                        class="form-control"
                        name="content"
                        id="content"
                        cols="30"
                        rows="3"
                        (select)="select($event);mouse_obj.target = 0"
                        (click)="select($event);mouse_obj.target = 0"
                        (keyup)="select($event);mouse_obj.target = 0"
                        class="form-control"
                    ></textarea>
                    <div class="{{setting_data.content.length>48?'red':''}}">字數:{{setting_data.content.length}}</div>
                    <div class="tips">最後網址長度為22</div>
                </div>
            </div>
            <span *ngIf="setting_data.id>0||setting_data.id=='-999'">
                <div class="mt-3">
                    <label for="number" class="form-check-label">寄送簡訊數量：</label>
                    <input type="number" id="number" class="form-control" [(ngModel)]="setting_data.send_num"/>
                </div>
                <div class="mt-3">
                    <label for="number" class="form-check-label">App入口：</label>
                    <select class="form-control" style="width: 160px;display: inline-block;margin:10px" [(ngModel)]="setting_data.route_sign">
                        <!-- <option selected="true" [ngValue]="'1'" disabled="true">個人頁</option> -->
                        <option *ngFor="let item of route_sign_list" [ngValue]="item.id">{{item.name}}</option>
                    </select>
                </div>
                <div class="mt-3">
                    <label for="number" class="form-check-label">開始發送時間</label>
                    <input type="datetime-local" class="form-control" style="width:220px"  (change)="check(0)"(ngModelChange)="setting_data.start_time = $event" [min]="minDate()"  [ngModel]="setting_data.start_time | date:'yyyy-MM-ddTHH:mm'" />
                </div>
                <div class="mt-3">
                    <label for="content" class="form-check-label">狀態：</label>
                    <div class="form-check form-check-inline">
                        <input
                            [(ngModel)]="setting_data.status"
                            class="form-check-input"
                            type="radio"
                            name="status"
                            (click)="setting_data.status='1'"
                            id="status1"
                            value="1"
                        />
                        <label class="form-check-label" for="status1">上架</label>
                    </div>
                    <div class="form-check form-check-inline">
                        <input
                            [(ngModel)]="setting_data.status"
                            class="form-check-input"
                            type="radio"
                            name="status"
                            (click)="setting_data.status='0'"
                            id="status0"
                            value="0"
                        />
                        <label class="form-check-label" for="status0">下架</label>
                    </div>
                </div>
                <!-- <div class="mt-3">
                    <label for="content" class="form-check-label">性別：</label>
                    <div class="form-check form-check-inline">
                        <input
                            [(ngModel)]="setting_data.gender"
                            class="form-check-input"
                            type="radio"
                            name="gender"
                            id="gender1"
                            (click)="setting_data.gender='1'"
                            value="1"
                        />
                        <label class="form-check-label" for="gender1">男</label>
                    </div>
                    <div class="form-check form-check-inline">
                        <input
                            [(ngModel)]="setting_data.gender"
                            class="form-check-input"
                            type="radio"
                            name="gender"
                            (click)="setting_data.gender='2'"
                            id="gender2"
                            value="2"
                        />
                        <label class="form-check-label" for="gender2">女</label>
                    </div>
                </div> -->
                <div class="mt-3">
                    <label for="content" class="form-check-label">老友獎勵：</label>
                    <div class="form-check form-check-inline">
                        <input
                            [(ngModel)]="setting_data.gift_type"
                            class="form-check-input"
                            type="radio"
                            name="diamond_type"
                            id="diamond_type1"
                            value="1"
                        />
                        <label class="form-check-label" for="diamond_type1">鑽石</label>
                    </div>
                    <div class="form-check form-check-inline">
                        <input
                            [(ngModel)]="setting_data.gift_type"
                            class="form-check-input"
                            type="radio"
                            name="diamond_type"
                            id="diamond_type2"
                            value="0"
                            [attr.disabled]="setting_data.gender=='2' ? '' : null"
                        />
                        <label class="form-check-label" for="diamond_type2">背包物品</label>
                    </div>
                    <div class="mt-3">
                        <label for="number" class="form-check-label">贈送數量：</label>
                        <input type="number" id="number" class="form-control" [(ngModel)]="setting_data.gift_num"/>
                    </div>
                </div>
                <!-- <div class="mt-3">
                    <label for="number" class="form-check-label">幾個月未上才通知</label>
                    <input type="number" id="number" class="form-control" [(ngModel)]="setting_data.month"/>
                </div> -->
                <div class="mt-3">
                    <app-tagselect [groupTagArr]="groupTagArr" (item)="calltagList($event)"></app-tagselect>
                </div>

                <div class="mt-3">
                    <label for="content" class="form-check-label">是否開啟推播：</label>
                    <div class="form-check form-check-inline">
                        <input
                            [(ngModel)]="setting_data.push_type"
                            class="form-check-input"
                            type="radio"
                            name="msg"
                            id="msg1"
                            value="1"
                        />
                        <label class="form-check-label" for="msg1">是</label>
                    </div>
                    <div class="form-check form-check-inline">
                        <input
                            [(ngModel)]="setting_data.push_type"
                            class="form-check-input"
                            type="radio"
                            name="msg"
                            id="msg2"
                            value="2"
                        />
                        <label class="form-check-label" for="msg2">否</label>
                    </div>
                    <div class="form-check form-check-inline">
                        <input
                            [(ngModel)]="setting_data.push_type"
                            class="form-check-input"
                            type="radio"
                            name="msg"
                            id="msg3"
                            value="0"
                        />
                        <label class="form-check-label" for="msg3">不限</label>
                    </div>
                </div>
                <!-- <div class="mt-3">
                    <label for="content" class="form-check-label">是否儲值：</label>
                    <div class="form-check form-check-inline">
                        <button  [ngClass]="setting_data.recharge_type==-1?'btn-danger':'btn-secondary'"   (click)="setting_data.recharge_type=-1;" class="btn">不限</button>
                        <button  [ngClass]="setting_data.recharge_type==0?'btn-danger':'btn-secondary'" (click)="setting_data.recharge_type=0" class="btn">否</button>
                        <button  [ngClass]="setting_data.recharge_type>=1?'btn-danger':'btn-secondary'" (click)="setting_data.recharge_type=setting_data.recharge_type<1?1:setting_data.recharge_type" class="btn">是</button>
                    </div>
                </div> -->
                <!-- <div class="mt-3" *ngIf="setting_data.recharge_type>0">
                    <label for="number" class="form-check-label">儲值金額大於</label>
                    <input class="form-control" style="width: 160px;display: inline-block;" type="number"  [(ngModel)]="setting_data.recharge_type">元
                </div> -->
                <div  class="mt-3">
                    <h5 for="file">附帶檔案</h5>
                    <button *ngIf="setting_data.file_url.length!=0" style="margin: 8px;" (click)="setting_data.file_url=''" class="btn btn-danger">取消夾帶檔案</button>
                    <a target="_blank" *ngIf="setting_data.file_url.length!=0" href="{{setting_data.file_url}}">連結</a>
                    <div *ngIf="setting_data.file_url.length==0">
                        <div class="btn btn-info" style="position:relative;margin-left:10px;margin-bottom: 8px;">
                            <input style="opacity:0;width:100%;height:100%;position:absolute;left:0;top:0;" type="file"   id="file"  (change)="handleFileInput($event.target.files)" placeholder="Upload file"  accept=".jpg,.jpeg,.mp4,.png">點我上傳
                        </div>
                        <div style="visibility: hidden;position:absolute;left:0">
                            <canvas></canvas>
                            <video id="small_show" style="width:200px;"  controls src=""></video>
                        </div>
                    </div>
                </div>
            </span>
        </div>
    </div>

    <!-- Modal footer -->
    <div class="modal-footer" *ngIf="subnow=='2'">
        <button
            id="ModalClose"
            type="button"
            (click)="get_track_detail()"
            class="btn btn-danger"
            data-dismiss="modal"
        >
            確定
        </button>
    </div>
    <div class="modal-footer" *ngIf="subnow=='1'">
        <button *ngIf="!ck_status"  (click)="check(1)"  class="btn btn-primary">儲存</button>
        <button
            *ngIf="ck_status"
            id="ModalClose"
            type="button"
            (click)="save()"
            class="btn btn-primary"
            data-dismiss="modal"
        >
            儲存
        </button>
        <button
            id="ModalClose"
            type="button"
            (click)="init_list()"
            class="btn btn-danger"
            data-dismiss="modal"
        >
            取消
        </button>
    </div>
</div>

<app-spinner [loading]="loading"></app-spinner>
